import { useEffect } from "react";

import { Navigation } from "fond/projects/Navigation";
import { updateFilter } from "fond/projects/redux";
import { useAppDispatch } from "fond/utils/hooks";
import { PageContent } from "fond/widgets";

import SharedContentList from "./SharedContentList";

const SharedWithMe: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(updateFilter("shared"));
  }, [dispatch]);

  return (
    <PageContent
      windowTitle="Shared with me"
      title="Shared with me"
      subTitle="BY TEAM MEMBERS"
      mainContent={<SharedContentList />}
      testId="filter-shared"
      navigation={<Navigation />}
    />
  );
};

export default SharedWithMe;
